<router-outlet  (activate)="onActivate($event)"></router-outlet>

<app-footer></app-footer>